export default {
    install(Vue, option) {
        Vue.prototype.$Formatter = new (function () {
            this.getServiceName = function(planName, planType = '') {
                if (!planType || planType === planName) {
                    return planName
                }

                return `${planType} - ${planName}`
            }

            this.getOrderId = function(item) {
                if (!item) return '';
                return `${item.create_date.substring(2, 4)}${this.pad(item.id, 4)}`
            }

            // ------ Date related
            const getDateByTimezone = ({ givenDate = null, timezone = 0 }) => {
                const event = givenDate ? new Date(givenDate) : new Date();
                event.setUTCHours(event.getUTCHours() + timezone);
        
                const year = event.getUTCFullYear();
                const month = event.getUTCMonth() + 1;
                const date = event.getUTCDate();
                const hour = event.getUTCHours();
                const minute = event.getUTCMinutes();
        
                return new Date(`${year}-${month < 10 ? `0${month}` : month}-${date < 10 ? `0${date}` : date}T${hour < 10 ? `0${hour}` : hour}:${minute < 10 ? `0${minute}` : minute}`);
            };

            this.getToday = () => {
                return new Date();

                // return getDateByTimezone({
                //     givenDate: new Date(Date.now()),
                //     timezone: 8
                // });
            }

            /**
            * 
            * @param {String} d - YYYY-MM-DD | [YYYY-MM-DD]T[HH:MM:SS]
            * @returns Number - weekday number
            */
            this.getDay = (d) => {
                if (d.length > 10) {
                    return new Date(`${d.split('T')[0]}T12:00:00+08:00`).getDay();
                }

                return new Date(`${d}T12:00:00+08:00`).getDay();
            }

            /**
            * 
            * @param {String} d - YYYY-MM-DD | [YYYY-MM-DD]T[HH:MM:SS]
            * @returns Date
            */
            this.convertStrToDate = (d) => {
                if (d.length > 10) {
                    return new Date(`${d.split('T')[0]}T12:00:00+08:00`);
                }

                return new Date(`${d}T12:00:00+08:00`);
            }

            /**
             * 
             * @param {Number} year 
             * @param {Number} month - start from 0 to 6
             * @param {Number} date 
             * @returns Date
             */
            this.formatDateToDate = (year, month, date) => {
                return this.convertStrToDate(`${year}-${this.pad(month + 1)}-${this.pad(date)}`);
            }

            /**
            * 
            * @param {String} e - YYYY-MM-DD | [YYYY-MM-DD]T[HH:MM:SS]
            * @returns Number - date
            */
            this.dayFormat = (e) => {
                return parseInt(e.substring(8, 10), 10).toString()
            }

            /**
             * 
             * @param {*} d - new Date()
             * @returns String - YYYY-MM-DD
             */
            this.formatDate = d => {
                return `${d.getFullYear()}-${d.getMonth() + 1 < 10 ? `0${d.getMonth() + 1}` : d.getMonth() + 1}-${d.getDate() < 10 ? `0${d.getDate()}` : d.getDate()
                    }`
            }

            this.displayCreateDate = (date, showTime = true) => {
                const regFullDate = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/;

                if (date && regFullDate.test(date)) {
                    let s = date.substring(0,10);
                    if (showTime) {
                        s += ' ' + date.split('T')[1].substring(0, 8);
                    }

                    return s;
                } else {
                    return date;
                }
            }

            this.getDaysDiff = function(d1, d2) {
                d1.setHours(0,0,0,0)
                d2.setHours(0,0,0,0)
                return Math.abs((d1.getTime() - d2.getTime()) / (1000 * 60 * 60 * 24));
            }

            // ----- Others
            /**
             * 
             * @param {Number | String} n - text/number will be padded
             * @param {Number} l - padded text length
             * @param {String} c - added string 
             * @param {Boolean} r - add text to left-hand-side
             * @param {Boolean} b 
             * @returns 
             */
            this.pad = (n, l, c, r, b) => {
                var s = n.toString(),
                    l = l || 2,
                    r = r !== false,
                    b = b !== false;
                if (s.length > 0) {
                    var p = "";
                    if (!isNaN(n) && s.charAt(0) == "-") {
                        p = "-";
                        s = s.substring(1);
                    }
                    while (s.length < l) {
                        if (r) s = (c || "0") + s;
                        else s += c || "0";
                    }
                    return b ? p + s : s;
                } else return "";
            }

            this.separator = (n, c, l) => {
                var l = l || 3;
                var r = new RegExp("\\B(?=(\\d{" + l + "})+(?!\\d))", "g");
                var p = n.toString().split(".");
                p[0] = p[0].replace(r, c || ",");
                return p.join(".");
            }

            /**
             * 
             * @param {Number} number 
             * @param {Number} decPlace - 取小數點後幾多個位
             * @returns Number
             */
            this.roundUp = (number, decPlace = 1) => {
                const multiplier = Math.pow(10, decPlace || 0);
                return Math.ceil(parseFloat(number) * multiplier) / multiplier;
            }

            this.convertToNum = (n, isInt = false) => {
                if (n !== undefined && n !== null && n !== '' && !isNaN(Number(n))) {
                    if (isInt === true) {
                        return parseInt(n);
                    } else {
                        return parseFloat(n);
                    }
                }

                return 0;
            }

            this.maskFormat = (val, mask, separator) => {
                const limit = mask.reduce((a, b) =>  a + b, 0);
                let str = "";
                let count = 0;

                if (val) {
                    const arrs = val.split('');
                    for (let i = 0; i < arrs.length; i++) {
                        const e = arrs[i];
                        var id = mask[count];
                        var prev = 0;
                        for (var j = 0; j < count; j++) {
                            prev += mask[j];
                        }
                        var pos = id + prev;
            
                        if (i + 1 < pos) {
                            str += e;
                        } else if (count < mask.length - 1) {
                            str += e + separator;
                            count++;
                        } else if (i < limit) {
                            str += e;
                        }
                    }
                }
             
                return str;
            }

            this.numbersOnlyString = (string) => {
                let str = "";
                if (string) {
                    for (let i = 0; i < string.length; i++) {
                        let currentChar = string.charAt(i);
                        let isValid = !isNaN(parseInt(currentChar));
                        if (isValid) { str += currentChar; }
                    }
                }
               
                return str;
            }

            // ----- Keydown Events
            this.number = event => {
                // [0-9]
                if (event.charCode >= 48 && event.charCode <= 57) {
                    return true
                }

                return event.preventDefault()
            }

            this.floating = event => {
                // [0-9][.][0-9]
                if ((event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46) {
                    return true
                }

                return event.preventDefault()
            }

            this.numberWithNegative = event => {
                // [-][0-9]
                if ((event.charCode >= 48 && event.charCode <= 57) || event.charCode === 45) {
                    return true
                }

                return event.preventDefault()
            }

            this.floatingWithNegative = event => {
                // [-][0-9][.][0-9]
                if ((event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46 || event
                    .charCode === 45) {
                    return true
                }

                return event.preventDefault()
            }

            this.alphaNumeric = event => {
                // [0-9A-Za-z]
                if (
                    (event.charCode >= 48 && event.charCode <= 57) ||
                    (event.charCode >= 65 && event.charCode <= 90) ||
                    (event.charCode >= 97 && event.charCode <= 122)
                ) {
                    return true
                }

                return event.preventDefault()
            }

            this.phone = event => {
                // +[0-9]
                if (event.charCode >= 48 && event.charCode <= 57 || event.charCode === 43) {
                    return true
                }

                return event.preventDefault()
            }

            this.engName = event => {
                // [a-zA-Z\s.]
                if (
                    (event.charCode >= 65 && event.charCode <= 90) ||
                    (event.charCode >= 97 && event.charCode <= 122) ||
                    event.charCode === 32 || event.charCode === 46
                ) {
                    return true
                }

                return event.preventDefault()
            }

            this.username = event => {
                // [0-9A-Za-z_-]
                if (
                    (event.charCode >= 48 && event.charCode <= 57) ||
                    (event.charCode >= 65 && event.charCode <= 90) ||
                    (event.charCode >= 97 && event.charCode <= 122) ||
                    event.charCode === 45 ||
                    event.charCode === 95
                ) {
                    return true
                }

                return event.preventDefault()
            }

            this.date = event => {
                // [0-9]
                if (event.charCode >= 48 && event.charCode <= 57 || event.charCode === 45) {
                    return true
                }

                return event.preventDefault()
            }
        })()
    }
}